import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { BetCancelStore } from "@state/stores/my-bets/BetCancelStore";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { observer } from "mobx-react";

export const BetDetailsBetCancelMessage = observer(
	function BetDetailsBetCancelMessage() {
		const { t } = useTranslation();
		const store = useContext(BetDetailsModalStoreContext);

		let betCancelStore: BetCancelStore;

		if (store instanceof BetDetailsModalStore) {
			betCancelStore = store.myBetsStore.betCancelStore;
		} else {
			betCancelStore = store.betCancelStore;
		}

		if (betCancelStore.betCancelMessage == null) {
			return null;
		}

		return (
			<div className="popup__footer popup__footer--bordered">
				<div className="popup__header u-padd--reset">
					{t<string>("mybets:BET_CANCEL.INFO_TITLE")}
				</div>
				<div className="popup__footer__row">
					<InfoMessageComponent
						type="note"
						message={betCancelStore.betCancelMessage as string}
					/>
				</div>
				<div className="popup__footer u-padd--reset">
					<button
						className="popup__btn popup__btn--secondary btn btn--base btn--primary--inverted"
						type="button"
						onClick={() => {
							betCancelStore.onExitBetCancelBetDetailsModal();
							store.onBetCancelClose();
						}}
					>
						{t<string>("COMMON.CLOSE")}
					</button>
				</div>
			</div>
		);
	}
);
